const $c5c12cc6dc5fd685$var$eventAdded = {};
const $c5c12cc6dc5fd685$var$addEventListeners = (elements)=>{
    elements.forEach((el, i)=>{
        if ($c5c12cc6dc5fd685$var$eventAdded[i]) return;
        $c5c12cc6dc5fd685$var$eventAdded[i] = true;
        el.addEventListener('mouseenter', (e)=>{
            const dropdown = e.currentTarget.querySelector('.dropdown');
            const rect = dropdown.getBoundingClientRect();
            if (rect.right > window.innerWidth) el.classList.add('left');
            else el.classList.remove('left');
            delete $c5c12cc6dc5fd685$var$eventAdded[i];
        }, {
            once: true
        });
    });
};
const $c5c12cc6dc5fd685$export$a4db3bf4a43c81e3 = (targetEl)=>{
    const target = targetEl || document;
    const buttonDropdowns = target.querySelectorAll('.button-list .has-dropdown');
    $c5c12cc6dc5fd685$var$addEventListeners(buttonDropdowns);
    window.addEventListener('resize', ()=>{
        $c5c12cc6dc5fd685$var$addEventListeners(buttonDropdowns);
    });
};


const $f8b375dfe567b691$var$activeClass = 'active';
const $f8b375dfe567b691$var$bodySelector = '.collapsible-body';
const $f8b375dfe567b691$var$groupSelector = '.collapsible-group';
const $f8b375dfe567b691$var$headerSelector = '.collapsible-header';
const $f8b375dfe567b691$var$contentSelector = '.collapsible-content';
const $f8b375dfe567b691$var$itemSelector = '.collapsible';
const $f8b375dfe567b691$var$standaloneSelector = `${$f8b375dfe567b691$var$itemSelector}.standalone`;
const $f8b375dfe567b691$var$animationDuration = 200;
let $f8b375dfe567b691$var$updateAriaLabels = (el, open)=>{
    const header = el.querySelector($f8b375dfe567b691$var$headerSelector);
    header.setAttribute('aria-expanded', `${open}`);
};
const $f8b375dfe567b691$var$closeCollapsible = (el)=>{
    if (el.classList.contains($f8b375dfe567b691$var$activeClass)) {
        const body = el.querySelector($f8b375dfe567b691$var$bodySelector);
        body.style.height = '0px';
        el.classList.remove($f8b375dfe567b691$var$activeClass);
        $f8b375dfe567b691$var$updateAriaLabels(el, false);
        setTimeout(()=>{
            body.style.removeProperty('height');
        }, $f8b375dfe567b691$var$animationDuration);
    }
};
let $f8b375dfe567b691$var$openCollapsible = (el)=>{
    const offsetHeight = el.querySelector($f8b375dfe567b691$var$contentSelector).offsetHeight;
    const body = el.querySelector($f8b375dfe567b691$var$bodySelector);
    body.style.height = `${offsetHeight}px`;
    el.classList.add($f8b375dfe567b691$var$activeClass);
    $f8b375dfe567b691$var$updateAriaLabels(el, true);
};
const $f8b375dfe567b691$var$animateCollapsible = (el, siblings)=>{
    el.querySelector($f8b375dfe567b691$var$headerSelector).addEventListener('click', ()=>{
        const isActive = el.classList.contains($f8b375dfe567b691$var$activeClass);
        if (siblings) siblings.forEach((sibling)=>$f8b375dfe567b691$var$closeCollapsible(sibling));
        if (!isActive) $f8b375dfe567b691$var$openCollapsible(el);
        else if (!siblings) $f8b375dfe567b691$var$closeCollapsible(el);
    });
};
const $f8b375dfe567b691$export$34107ba18b519094 = (targetEl)=>{
    const target = targetEl || document;
    const lists = target.querySelectorAll($f8b375dfe567b691$var$groupSelector);
    const standalone = target.querySelectorAll($f8b375dfe567b691$var$standaloneSelector);
    lists.forEach((wrapper)=>{
        const collapsibles = wrapper.querySelectorAll($f8b375dfe567b691$var$itemSelector);
        collapsibles.forEach((el)=>{
            $f8b375dfe567b691$var$animateCollapsible(el, collapsibles);
        });
    });
    standalone.forEach((el)=>$f8b375dfe567b691$var$animateCollapsible(el, false));
};


function $f0e8230e30da36c4$var$confirmable(e, msg) {
    if (confirm(msg) != true) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
    }
}
function $f0e8230e30da36c4$export$7d03d001ca71c65f(targetEl) {
    const target = targetEl || document;
    target.querySelectorAll('[data-confirmable]').forEach((form)=>{
        const msg = form.dataset.confirmable || 'Are you sure you want to do this?';
        form.addEventListener('submit', (e)=>$f0e8230e30da36c4$var$confirmable(e, msg));
    });
}


function $562ab1c19ca475c0$var$getFormValues(form) {
    var inputs = form.querySelectorAll('[name]');
    return [
        ...inputs
    ].reduce((acc, curr)=>{
        return {
            ...acc,
            [curr.name]: curr.value
        };
    }, {});
}
function $562ab1c19ca475c0$export$70070ff97f1a4ca0(targetEl) {
    const target = targetEl || document;
    var originalValues = {};
    const forms = [
        ...target.querySelectorAll('[data-detect-unsaved-changes]')
    ];
    function handleWindowUnload(e) {
        var unsubmitted = forms.find((form, i)=>{
            var values = $562ab1c19ca475c0$var$getFormValues(form);
            return JSON.stringify(values) != JSON.stringify(originalValues[i]);
        });
        if (unsubmitted) {
            e.preventDefault();
            e.returnValue = false;
        }
    }
    forms.forEach((form, i)=>{
        var values = $562ab1c19ca475c0$var$getFormValues(form);
        originalValues[i] = values;
        form.addEventListener('submit', ()=>{
            window.removeEventListener('beforeunload', handleWindowUnload);
        });
    });
    window.addEventListener('beforeunload', handleWindowUnload);
    target.querySelectorAll('form').forEach((form)=>{
        const resetButtons = form.querySelectorAll('[data-reset-form]');
        if (resetButtons.length) resetButtons.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                form.reset();
            });
        });
    });
}


var $de865fc1d99bd139$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $de865fc1d99bd139$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $af31d22fe4705f19$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $af31d22fe4705f19$export$2e2bcd8739ae039 = $af31d22fe4705f19$export$33e6c23ebe2ee669;


var $634a1be5d01732f1$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $634a1be5d01732f1$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $634a1be5d01732f1$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $634a1be5d01732f1$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $9b9f8cb62c2a4ebb$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $9b9f8cb62c2a4ebb$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $9b9f8cb62c2a4ebb$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $9b9f8cb62c2a4ebb$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $b394b1baa540f1a8$var$doNothing = function() {
    return undefined;
};
var $b394b1baa540f1a8$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $b394b1baa540f1a8$export$9490b78b888a863f = {
    D: $b394b1baa540f1a8$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $b394b1baa540f1a8$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $b394b1baa540f1a8$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $b394b1baa540f1a8$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $b394b1baa540f1a8$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$b394b1baa540f1a8$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $b394b1baa540f1a8$export$27a2dd9af757e89c($b394b1baa540f1a8$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $634a1be5d01732f1$export$5d04458e2a6c373e)($b394b1baa540f1a8$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $b394b1baa540f1a8$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $84b5a417781eae90$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $de865fc1d99bd139$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $af31d22fe4705f19$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $b394b1baa540f1a8$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $b394b1baa540f1a8$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $84b5a417781eae90$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $de865fc1d99bd139$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $af31d22fe4705f19$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $de865fc1d99bd139$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $b394b1baa540f1a8$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $b394b1baa540f1a8$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $b394b1baa540f1a8$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $84b5a417781eae90$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $84b5a417781eae90$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $84b5a417781eae90$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $84b5a417781eae90$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $84b5a417781eae90$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $84b5a417781eae90$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $84b5a417781eae90$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $2a5e2989a9be5999$var$__assign = undefined && undefined.__assign || function() {
    $2a5e2989a9be5999$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2a5e2989a9be5999$var$__assign.apply(this, arguments);
};
var $2a5e2989a9be5999$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $2a5e2989a9be5999$var$DEBOUNCED_CHANGE_MS = 300;
function $2a5e2989a9be5999$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $2a5e2989a9be5999$var$__assign($2a5e2989a9be5999$var$__assign({}, (0, $de865fc1d99bd139$export$ebe90cb607ad99e)), $2a5e2989a9be5999$var$flatpickr.defaultConfig),
        l10n: (0, $af31d22fe4705f19$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $84b5a417781eae90$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $84b5a417781eae90$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $84b5a417781eae90$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $84b5a417781eae90$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $84b5a417781eae90$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $84b5a417781eae90$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $84b5a417781eae90$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $84b5a417781eae90$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $84b5a417781eae90$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $634a1be5d01732f1$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $634a1be5d01732f1$export$61fc7d43ac8f84b0)(triggerChange, $2a5e2989a9be5999$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $84b5a417781eae90$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $84b5a417781eae90$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $84b5a417781eae90$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $9b9f8cb62c2a4ebb$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $9b9f8cb62c2a4ebb$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $b394b1baa540f1a8$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $9b9f8cb62c2a4ebb$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $9b9f8cb62c2a4ebb$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $84b5a417781eae90$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $9b9f8cb62c2a4ebb$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $9b9f8cb62c2a4ebb$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $9b9f8cb62c2a4ebb$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $9b9f8cb62c2a4ebb$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $2a5e2989a9be5999$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $2a5e2989a9be5999$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $84b5a417781eae90$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $84b5a417781eae90$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $84b5a417781eae90$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $84b5a417781eae90$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $84b5a417781eae90$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $2a5e2989a9be5999$var$__assign($2a5e2989a9be5999$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $2a5e2989a9be5999$var$flatpickr.defaultConfig.dateFormat || (0, $de865fc1d99bd139$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $2a5e2989a9be5999$var$flatpickr.defaultConfig.altFormat || (0, $de865fc1d99bd139$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $de865fc1d99bd139$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $634a1be5d01732f1$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $de865fc1d99bd139$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $634a1be5d01732f1$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $2a5e2989a9be5999$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $2a5e2989a9be5999$var$__assign($2a5e2989a9be5999$var$__assign({}, $2a5e2989a9be5999$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $2a5e2989a9be5999$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $b394b1baa540f1a8$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $b394b1baa540f1a8$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $b394b1baa540f1a8$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $b394b1baa540f1a8$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $b394b1baa540f1a8$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $2a5e2989a9be5999$var$__assign($2a5e2989a9be5999$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $2a5e2989a9be5999$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $84b5a417781eae90$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $84b5a417781eae90$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $9b9f8cb62c2a4ebb$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $9b9f8cb62c2a4ebb$export$25245567f53f158f)((0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $84b5a417781eae90$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $de865fc1d99bd139$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $634a1be5d01732f1$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $9b9f8cb62c2a4ebb$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $84b5a417781eae90$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $84b5a417781eae90$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $84b5a417781eae90$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $b394b1baa540f1a8$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $9b9f8cb62c2a4ebb$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(isHourElem) && (0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $634a1be5d01732f1$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $634a1be5d01732f1$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $2a5e2989a9be5999$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $2a5e2989a9be5999$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $2a5e2989a9be5999$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $2a5e2989a9be5999$var$_flatpickr([
            this
        ], config);
    };
}
var $2a5e2989a9be5999$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $2a5e2989a9be5999$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $2a5e2989a9be5999$var$_flatpickr([
        selector
    ], config);
    else return $2a5e2989a9be5999$var$_flatpickr(selector, config);
};
$2a5e2989a9be5999$var$flatpickr.defaultConfig = {};
$2a5e2989a9be5999$var$flatpickr.l10ns = {
    en: $2a5e2989a9be5999$var$__assign({}, (0, $af31d22fe4705f19$export$2e2bcd8739ae039)),
    default: $2a5e2989a9be5999$var$__assign({}, (0, $af31d22fe4705f19$export$2e2bcd8739ae039))
};
$2a5e2989a9be5999$var$flatpickr.localize = function(l10n) {
    $2a5e2989a9be5999$var$flatpickr.l10ns.default = $2a5e2989a9be5999$var$__assign($2a5e2989a9be5999$var$__assign({}, $2a5e2989a9be5999$var$flatpickr.l10ns.default), l10n);
};
$2a5e2989a9be5999$var$flatpickr.setDefaults = function(config) {
    $2a5e2989a9be5999$var$flatpickr.defaultConfig = $2a5e2989a9be5999$var$__assign($2a5e2989a9be5999$var$__assign({}, $2a5e2989a9be5999$var$flatpickr.defaultConfig), config);
};
$2a5e2989a9be5999$var$flatpickr.parseDate = (0, $84b5a417781eae90$export$cfa2ef2687faeda2)({});
$2a5e2989a9be5999$var$flatpickr.formatDate = (0, $84b5a417781eae90$export$ff1a0b75284ac636)({});
$2a5e2989a9be5999$var$flatpickr.compareDates = (0, $84b5a417781eae90$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $2a5e2989a9be5999$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $2a5e2989a9be5999$var$flatpickr;
var $2a5e2989a9be5999$export$2e2bcd8739ae039 = $2a5e2989a9be5999$var$flatpickr;


const $cc6bb940a375faba$var$globalConfig = {
    locale: {
        firstDayOfWeek: 1
    },
    altInput: true,
    time_24hr: true,
    minuteIncrement: 1,
    altFormat: 'd.m.Y'
};
const $cc6bb940a375faba$var$timePickerConfig = {
    allowInput: true,
    dateFormat: 'H:i',
    enableTime: true,
    noCalendar: true,
    time_24hr: true
};
function $cc6bb940a375faba$export$ed8a68ffbc322e67(config = {}, targetEl) {
    const target = targetEl || document;
    (0, $2a5e2989a9be5999$export$2e2bcd8739ae039).localize({
        firstDayOfWeek: 1
    });
    target.querySelectorAll('.datepicker').forEach((e)=>{
        const disablePast = Boolean(e.dataset.disablePast);
        const disableFuture = Boolean(e.dataset.disableFuture);
        const enableTime = Boolean(e.dataset.enableTime);
        const timeOnly = Boolean(e.dataset.timeOnly);
        const datePickerConfig = {
            ...$cc6bb940a375faba$var$globalConfig,
            ...enableTime ? {
                altFormat: 'd.m.Y H:i'
            } : {},
            ...config,
            minDate: disablePast ? new Date() : null,
            maxDate: disableFuture ? new Date() : null,
            enableTime: enableTime
        };
        (0, $2a5e2989a9be5999$export$2e2bcd8739ae039)(e, timeOnly ? $cc6bb940a375faba$var$timePickerConfig : datePickerConfig);
    });
}


function $c3a7231574a3ce7f$export$a4d38683f8b8b9ce(targetEl) {
    const target = targetEl || document;
    target.querySelectorAll('.file-input').forEach((elm)=>{
        const input = elm.querySelector('input[type="file"]');
        const label = elm.querySelector('.file-name');
        if (input && label) input.addEventListener('change', (e)=>{
            const filename = e.target.files[0].name || '';
            label.textContent = filename;
        });
    });
}


const $304388bf04a27446$var$defaultDisableFor = '[data-disable-interfere-submit]';
const $304388bf04a27446$var$disableSubmit = (elm)=>{
    const icon = document.createElement('i');
    icon.classList.add('icon-spinner-outline', 'rotate');
    elm.classList.add('has-icon');
    elm.appendChild(icon);
    elm.disabled = true;
};
function $304388bf04a27446$export$823a7882fb5f7a04(config = {}, targetEl) {
    const target = targetEl || document;
    const { enableFor: enableFor, disableFor: disableFor } = config;
    const selector = `form${enableFor || ''}:not(${disableFor || $304388bf04a27446$var$defaultDisableFor})`;
    const forms = [
        ...target.querySelectorAll(selector)
    ];
    forms.forEach((form)=>{
        let submitted = false;
        const submits = form.querySelectorAll('[type="submit"]');
        form.addEventListener('submit', (e)=>{
            if (submitted) e.preventDefault();
            submits.forEach($304388bf04a27446$var$disableSubmit);
            submitted = true;
        });
    });
}


const $35575bba3d0279d6$var$searchDelay = 200;
const $35575bba3d0279d6$var$noResultsMsg = 'No results found.';
const $35575bba3d0279d6$var$defaultQueryParam = 'search';
const $35575bba3d0279d6$var$apiResponseKeyMissing = 'You need to specify "data-value-key" and "data-label-key" if the API returns objects or "data-simple-values" if the API returns a list of strings';
const $35575bba3d0279d6$var$arbitraryInputError = '"data-arbitrary-input" is only allowed when "data-simple-values" is activated.';
const $35575bba3d0279d6$var$findFormGroupElement = (element, selector)=>{
    return element.closest('.form-group').querySelector(selector);
};
const $35575bba3d0279d6$var$insertAfter = (newNode, existing)=>{
    existing.parentNode.insertBefore(newNode, existing.nextSibling);
};
const $35575bba3d0279d6$var$createOptionsContainer = (input)=>{
    const container = document.createElement('div');
    container.classList.add('data-list');
    $35575bba3d0279d6$var$insertAfter(container, input);
    return container;
};
const $35575bba3d0279d6$var$createHiddenInput = (input, name)=>{
    const hiddenField = document.createElement('input');
    const originalValue = input.value;
    const label = input.dataset.preselectLabel;
    hiddenField.type = 'hidden';
    hiddenField.name = name;
    $35575bba3d0279d6$var$insertAfter(hiddenField, input);
    hiddenField.setAttribute('value', originalValue);
    input.setAttribute('value', label);
    return hiddenField;
};
const $35575bba3d0279d6$var$createClearIcon = (parent, input)=>{
    const icon = document.createElement('i');
    icon.classList.add('icon-close');
    parent.appendChild(icon);
    input.type = 'text';
    return icon;
};
const $35575bba3d0279d6$var$wrapElement = (input, classnames)=>{
    const container = document.createElement('div');
    container.classList.add(...classnames);
    input.parentNode.insertBefore(container, input);
    container.appendChild(input);
    return container;
};
class $35575bba3d0279d6$var$Search {
    constructor(input){
        const { arbitraryInput: arbitraryInput, labelKey: labelKey, name: name, onSelectCallback: onSelectCallback, preselectLabel: preselectLabel, queryParam: queryParam, resultsKey: resultsKey, simpleValues: simpleValues, url: url, valueKey: valueKey } = input.dataset;
        this.container = input.parentElement;
        this.input = input;
        this.latestSearchValue = preselectLabel || input.value;
        this.inputWrapper = $35575bba3d0279d6$var$wrapElement(this.input, [
            'relative',
            'grow'
        ]);
        this.optionsWrapper = $35575bba3d0279d6$var$findFormGroupElement(input, '[data-search-options]');
        this.optionsWrapper = $35575bba3d0279d6$var$createOptionsContainer(input);
        this.form = input.closest('form');
        this.name = name;
        this.url = url;
        this.queryParam = queryParam || $35575bba3d0279d6$var$defaultQueryParam;
        this.valueKey = valueKey;
        this.labelKey = labelKey;
        this.simpleValues = 'simpleValues' in input.dataset && simpleValues != 'false';
        this.resultsKey = resultsKey;
        this.searchTimeout = null;
        this.arbitraryInput = 'arbitraryInput' in input.dataset && arbitraryInput != 'false';
        this.onSelectCallback = onSelectCallback;
        if (!this.simpleValues && !this.valueKey && !this.labelKey) throw new Error($35575bba3d0279d6$var$apiResponseKeyMissing);
        if (this.arbitraryInput && !this.simpleValues) throw new Error($35575bba3d0279d6$var$arbitraryInputError);
        this.clearIcon = $35575bba3d0279d6$var$createClearIcon(this.inputWrapper, this.input);
        this.addClearListener();
        this.addKeyDownListener();
        this.addFocusListener();
        this.addKeyUpListener();
        this.addUnfocusEventListener();
    }
    addKeyDownListener() {
        this.input.addEventListener('keydown', ()=>{
            clearTimeout(this.searchTimeout);
        });
    }
    showOptions = ()=>{
        this.optionsWrapper.classList.add('active');
    };
    addFocusListener() {
        this.input.addEventListener('focusin', ()=>{
            this.showOptions();
        });
    }
    addClearListener() {
        this.clearIcon.addEventListener('click', ()=>{
            this.input.value = '';
            if (this.optionsWrapper) this.optionsWrapper.classList.remove('active');
            if (this.hiddeninput) this.hiddeninput.value = '';
        });
    }
    clearOptions() {
        this.optionsWrapper.replaceChildren();
    }
    setOptions(data) {
        let html;
        if (data.length) html = data.map((item)=>{
            let value, label;
            if (this.simpleValues) {
                value = item;
                label = item;
            } else {
                value = item.value;
                label = item.label;
            }
            const option = document.createElement('span');
            option.classList.add('data-item');
            option.dataset.value = value;
            option.innerText = label;
            if (this.selection && this.selection.includes(item.value) || this.hiddeninput && this.hiddeninput.value == item.value) option.classList.add('selected');
            else option.addEventListener('click', ()=>this.handleClick(item));
            return option;
        });
        else {
            const msg = document.createElement('span');
            msg.classList.add('data-item');
            msg.innerText = $35575bba3d0279d6$var$noResultsMsg;
            html = [
                msg
            ];
        }
        this.optionsWrapper.replaceChildren(...html);
    }
    addKeyUpListener() {
        this.input.addEventListener('keyup', (e)=>{
            const value = e.currentTarget.value;
            if (value == this.latestSearchValue) return;
            clearTimeout(this.searchTimeout);
            if (this.hiddeninput && this.arbitraryInput) this.hiddeninput.value = value;
            if (!value) {
                this.optionsWrapper.innerHTML = '';
                if (this.hiddeninput) this.hiddeninput.value = '';
                return;
            }
            const setLoading = ()=>{
                const spinner = document.createElement('i');
                spinner.classList.add('icon-spinner-outline', 'rotate');
                const spinnerWrapper = document.createElement('span');
                spinnerWrapper.classList.add('inset-xs', 'flexrow', 'justify-center');
                spinnerWrapper.appendChild(spinner);
                this.optionsWrapper.replaceChildren(spinnerWrapper);
            };
            const execSearch = async (searchValue)=>{
                this.latestSearchValue = searchValue;
                setLoading();
                this.showOptions();
                const requestUrl = `${this.url}?${this.queryParam}=${value}`;
                const response = await fetch(requestUrl);
                const results = await response.json();
                const data = this.resultsKey ? results[this.resultsKey] : results;
                let options;
                if (this.simpleValues) options = data;
                else options = data.map((item)=>{
                    return {
                        value: item[this.valueKey],
                        label: item[this.labelKey]
                    };
                });
                this.setOptions(options);
            };
            this.searchTimeout = setTimeout(()=>execSearch(value), $35575bba3d0279d6$var$searchDelay);
        });
    }
    addUnfocusEventListener() {
        document.addEventListener('click', (e)=>{
            if (!this.container.contains(e.target)) this.optionsWrapper.classList.remove('active');
        });
    }
    handleClick(item) {
        if (this.onSelectCallback && typeof window[this.onSelectCallback] === 'function') window[this.onSelectCallback](item);
    }
}
class $35575bba3d0279d6$var$SingleSearch extends $35575bba3d0279d6$var$Search {
    constructor(input){
        super(input);
        this.hiddeninput = $35575bba3d0279d6$var$createHiddenInput(input, this.name);
        this.required = this.input.required;
        this.setSubmitListener();
    }
    setSubmitListener() {
        if (this.form) this.form.addEventListener('submit', (e)=>{
            if (this.required && !this.hiddeninput.value) {
                e.preventDefault();
                this.input.setCustomValidity('Please fill in this field.');
            }
        });
    }
    handleClick(item) {
        this.input.setCustomValidity('');
        this.optionsWrapper.classList.remove('active');
        if (this.simpleValues) {
            this.hiddeninput.value = item;
            this.input.value = item;
        } else {
            this.hiddeninput.value = item.value;
            this.input.value = item.label;
        }
        this.clearOptions();
        super.handleClick(item);
    }
}
class $35575bba3d0279d6$var$MultiSearch extends $35575bba3d0279d6$var$Search {
    constructor(input){
        super(input);
        this.selectionWrapper = $35575bba3d0279d6$var$findFormGroupElement(this.input, '[data-search-selection]');
        this.selection = [];
        if (this.arbitraryInput) this.initArbitrarySearchInput();
        this.initSelection();
    }
    createSelectedItem({ value: value, label: label }) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.value = value;
        input.name = this.name;
        const tag = document.createElement('span');
        tag.setAttribute('data-selection-item', '');
        tag.innerText = label;
        const icon = document.createElement('i');
        icon.classList.add('icon-close');
        icon.addEventListener('click', ()=>this.removeSelected(tag, input.value));
        tag.appendChild(icon);
        tag.appendChild(input);
        if (!this.selection.includes(input.value)) {
            this.selectionWrapper.appendChild(tag);
            this.selection.push(input.value);
        }
    }
    initSelection() {
        const items = [
            ...this.selectionWrapper.querySelectorAll('[data-selection-item]')
        ];
        items.forEach((item)=>{
            const { value: value, label: label } = item.dataset;
            if (this.simpleValues) this.createSelectedItem({
                value: value,
                label: value
            });
            else this.createSelectedItem({
                value: value,
                label: label
            });
            item.remove();
        });
    }
    removeSelected(item, value) {
        item.remove();
        const index = this.selection.indexOf(value);
        this.selection.splice(index, 1);
    }
    initArbitrarySearchInput() {
        const container = $35575bba3d0279d6$var$wrapElement(this.inputWrapper, [
            'relative',
            'flexrow',
            'flex-gap-xs',
            'align-center'
        ]);
        const btn = document.createElement('button');
        btn.classList.add(...[
            'is-icon',
            'primary',
            'small'
        ]);
        const icon = document.createElement('i');
        icon.classList.add('icon-add');
        btn.appendChild(icon);
        btn.addEventListener('click', (e)=>{
            e.preventDefault();
            const value = this.input.value;
            this.createSelectedItem({
                value: value,
                label: value
            });
            this.input.value = '';
            this.clearOptions();
        });
        container.appendChild(btn);
    }
    handleClick(item) {
        const data = this.simpleValues ? {
            value: item,
            label: item
        } : item;
        this.createSelectedItem(data);
        this.optionsWrapper.classList.remove('active');
        this.clearOptions();
        super.handleClick(item);
    }
}
const $35575bba3d0279d6$export$aa70e201a98a0ce4 = (targetEl, selector = '[data-search]')=>{
    const target = targetEl || document;
    target.querySelectorAll(selector).forEach((el)=>{
        if (el.dataset.multi) new $35575bba3d0279d6$var$MultiSearch(el);
        else new $35575bba3d0279d6$var$SingleSearch(el);
    });
};


const $360e565dd160cbbd$var$activeClass = 'active';
const $360e565dd160cbbd$var$toggleModal = (modal, e)=>{
    const body = document.querySelector('body');
    if (e) e.preventDefault();
    body.toggleAttribute('data-noscroll');
    modal.classList.toggle($360e565dd160cbbd$var$activeClass);
};
const $360e565dd160cbbd$var$initCloseModal = (modal)=>{
    const close = modal.querySelectorAll('.modal-close');
    [
        ...close
    ].forEach((elm)=>elm.addEventListener('click', (e)=>$360e565dd160cbbd$var$toggleModal(modal, e)));
    modal.addEventListener('click', (e)=>{
        const target = e.target;
        if (!target.classList.contains('modal-body') && !target.closest('.modal-body')) $360e565dd160cbbd$var$toggleModal(modal, e);
    });
};
function $360e565dd160cbbd$export$60523367a7e10402(targetEl) {
    const target = targetEl || document;
    target.querySelectorAll('[data-modal]').forEach((trigger)=>{
        const id = trigger.dataset.modal;
        const modal = target.querySelector(`#${id}`);
        const toggle = (e)=>{
            $360e565dd160cbbd$var$toggleModal(modal, e);
        };
        trigger.addEventListener('click', toggle);
        $360e565dd160cbbd$var$initCloseModal(modal);
    });
}


function $713101f52d4e2e3f$var$fadeOut(elm) {
    elm.classList.add('fade-out', 'no-delay');
}
function $713101f52d4e2e3f$var$addCloseListener(notification) {
    const iconClose = notification.querySelector('.notification-close');
    if (iconClose) iconClose.addEventListener('click', ()=>$713101f52d4e2e3f$var$fadeOut(notification));
}
function $713101f52d4e2e3f$export$e30e8b9f67d70081(targetEl) {
    const target = targetEl || document;
    target.querySelectorAll('.notification-fixed').forEach($713101f52d4e2e3f$var$addCloseListener);
}


const $415c60d76e295d48$var$openClass = 'sidebar-open';
const $415c60d76e295d48$var$openingClass = 'sidebar-opening';
const $415c60d76e295d48$var$closedClass = 'sidebar-closed';
const $415c60d76e295d48$var$closingClass = 'sidebar-closing';
const $415c60d76e295d48$var$openCollapsibleClass = 'collapsible-open';
const $415c60d76e295d48$var$activeItemClass = 'active';
const $415c60d76e295d48$var$transitionDuration = 200;
const $415c60d76e295d48$var$collapsiblesStorageKey = 'econ-sidebar-collapsibles';
const $415c60d76e295d48$var$openStorageKey = 'econ-sidebar-open';
function $415c60d76e295d48$var$uniqueOnly(value, index, array) {
    return array.indexOf(value) === index;
}
function $415c60d76e295d48$var$removeFromArray(value, array) {
    const i = array.indexOf(value);
    if (i !== -1) array.splice(i, 1);
    return array;
}
// OPTIONS
// trackCollapsibles: will write the state of collapsibles to local storage and restore it on page load
class $415c60d76e295d48$var$Sidebar {
    constructor(sidebarEl, options){
        this.sidebarEl = sidebarEl;
        this.outsideToggle = document.querySelector('.sidebar-outside-switch');
        this.innerToggle = sidebarEl.querySelector('.sidebar-switch');
        this.collapsibles = [
            ...sidebarEl.querySelectorAll('.sidebar-collapsible')
        ];
        this.sidebarLinks = [
            ...sidebarEl.querySelectorAll('.sidebar-content a[href]')
        ];
        this.trackCollapsibles = options.trackCollapsibles;
        this.openCollapsibles = this.collapsibles.reduce((acc, el, index)=>{
            if (el.classList.contains($415c60d76e295d48$var$openCollapsibleClass)) return [
                ...acc,
                index
            ];
            return acc;
        }, []);
        this.isOpen = this.determineOpenInitially();
        this.addEventListeners();
        this.findActiveCollapsible();
        this.setActiveItems();
        this.onOpenChange();
        if (this.trackCollapsibles) this.handleStoredSidebarState();
    }
    get open() {
        return this.isOpen;
    }
    set open(value) {
        if (this.isOpen !== value) {
            this.isOpen = value;
            this.onOpenChange();
        }
    }
    isMobileView() {
        const toggleStyle = window.getComputedStyle(this.outsideToggle);
        return toggleStyle.display !== 'none';
    }
    determineOpenInitially() {
        if (this.trackCollapsibles && localStorage.getItem($415c60d76e295d48$var$openStorageKey) != null) return JSON.parse(localStorage.getItem($415c60d76e295d48$var$openStorageKey));
        if (this.sidebarEl.classList.contains($415c60d76e295d48$var$closedClass)) return false;
        if (this.sidebarEl.classList.contains($415c60d76e295d48$var$openClass)) return true;
        // If neither open nor closed classes are set, sidebar will be considered closed on mobile devices and open on desktop
        return !this.isMobileView();
    }
    addEventListeners() {
        this.innerToggle.addEventListener('click', ()=>this.toggleOpen());
        this.outsideToggle.addEventListener('click', ()=>this.toggleOpen());
        this.collapsibles.forEach((collapsible, index)=>{
            const btn = collapsible.children[0];
            if (btn && btn.tagName === 'BUTTON') btn.addEventListener('click', ()=>this.toggleCollapsibleOpen(collapsible, index));
        });
        // I have not found a reliable native way to listen to navigation changes, therefore using a custom event
        document.addEventListener('econ-sidebar-navigated', (e)=>{
            this.setActiveItems(e.detail?.path);
            if (this.isMobileView()) this.open = false;
        });
    }
    findActiveCollapsible() {
        this.collapsibles.forEach((collapsible)=>{
            const children = [
                ...collapsible.children
            ].find((child)=>child.tagName === 'UL');
            if (children) {
                const active = children.querySelector('.active');
                if (active) collapsible.classList.add($415c60d76e295d48$var$openCollapsibleClass);
            }
        });
    }
    setActiveItems(path = window.location.pathname) {
        this.collapsibles.forEach((collapsible)=>{
            collapsible.classList.remove($415c60d76e295d48$var$activeItemClass);
        });
        this.sidebarLinks.forEach((link)=>{
            if (link.getAttribute('href') === path) {
                link.classList.add($415c60d76e295d48$var$activeItemClass);
                const collapsible = link.closest('.sidebar-collapsible');
                if (collapsible) collapsible.classList.add($415c60d76e295d48$var$activeItemClass);
            } else link.classList.remove($415c60d76e295d48$var$activeItemClass);
        });
    }
    onOpenChange() {
        const open = this.isOpen;
        const handleTempClass = (className)=>{
            this.sidebarEl.classList.add(className);
            setTimeout(()=>this.sidebarEl.classList.remove(className), $415c60d76e295d48$var$transitionDuration);
        };
        if (open) {
            handleTempClass($415c60d76e295d48$var$openingClass);
            this.sidebarEl.classList.remove($415c60d76e295d48$var$closedClass);
            this.sidebarEl.classList.add($415c60d76e295d48$var$openClass);
        } else {
            handleTempClass($415c60d76e295d48$var$closingClass);
            this.sidebarEl.classList.remove($415c60d76e295d48$var$openClass);
            this.sidebarEl.classList.add($415c60d76e295d48$var$closedClass);
        }
    }
    toggleOpen() {
        this.open = !this.open;
    }
    toggleCollapsibleOpen(collapsible, index) {
        const collapsibleOpen = collapsible.classList.contains($415c60d76e295d48$var$openCollapsibleClass);
        if (!this.isOpen) {
            this.isOpen = true;
            setTimeout(()=>{
                collapsible.classList.add($415c60d76e295d48$var$openCollapsibleClass);
            }, $415c60d76e295d48$var$transitionDuration);
            return;
        }
        if (collapsibleOpen) {
            collapsible.classList.remove($415c60d76e295d48$var$openCollapsibleClass);
            this.openCollapsibles = $415c60d76e295d48$var$removeFromArray(index, this.openCollapsibles);
        } else {
            collapsible.classList.add($415c60d76e295d48$var$openCollapsibleClass);
            this.openCollapsibles = [
                ...this.openCollapsibles,
                index
            ].filter($415c60d76e295d48$var$uniqueOnly);
        }
    }
    handleStoredSidebarState() {
        window.addEventListener('beforeunload', ()=>this.writeSidebarStateToLocalStorage());
        this.openCollapsibles = JSON.parse(localStorage.getItem($415c60d76e295d48$var$collapsiblesStorageKey)) || [];
        this.openCollapsibles.forEach((index)=>{
            this.collapsibles[index].classList.add($415c60d76e295d48$var$openCollapsibleClass);
        });
    }
    writeSidebarStateToLocalStorage() {
        localStorage.setItem($415c60d76e295d48$var$collapsiblesStorageKey, JSON.stringify(this.openCollapsibles));
        localStorage.setItem($415c60d76e295d48$var$openStorageKey, JSON.stringify(this.open));
    }
}
const $415c60d76e295d48$export$4b39ebe2dc5b79d6 = (options = {})=>{
    const sidebarEl = document.querySelector('.sidebar');
    if (!sidebarEl) return null;
    return new $415c60d76e295d48$var$Sidebar(sidebarEl, options);
};


var $ff443a58ea3178ba$var$observeDOM = function() {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    return function(obj, callback) {
        if (!obj || obj.nodeType !== 1) return;
        if (MutationObserver) {
            // define a new observer
            var mutationObserver = new MutationObserver(callback);
            // have the observer observe foo for changes in children
            mutationObserver.observe(obj, {
                childList: true,
                subtree: true
            });
            return mutationObserver;
        } else if (window.addEventListener) {
            obj.addEventListener('DOMNodeInserted', callback, false);
            obj.addEventListener('DOMNodeRemoved', callback, false);
        }
    };
}();
var $ff443a58ea3178ba$var$hintClass = 'hint';
var $ff443a58ea3178ba$var$activeClassSortable = 'active';
var $ff443a58ea3178ba$var$originClass = 'origin';
function $ff443a58ea3178ba$var$slist(target) {
    target.classList.add('slist');
    var items = target.children, dragged = null;
    var currentLength = items.length;
    function addListener(i) {
        i.draggable = true;
        i.addEventListener('dragstart', function() {
            dragged = this;
            for (let it of items)it.classList.add(it != dragged ? $ff443a58ea3178ba$var$hintClass : $ff443a58ea3178ba$var$originClass);
        });
        i.addEventListener('dragenter', function() {
            if (this != dragged) {
                for (let item of items)item.classList.remove($ff443a58ea3178ba$var$activeClassSortable);
                this.classList.add($ff443a58ea3178ba$var$activeClassSortable);
            }
        });
        i.addEventListener('dragend', function() {
            for (let it of items)it.classList.remove($ff443a58ea3178ba$var$hintClass, $ff443a58ea3178ba$var$originClass, $ff443a58ea3178ba$var$activeClassSortable);
        });
        i.addEventListener('dragover', function(e) {
            e.preventDefault();
        });
        i.addEventListener('drop', function(e) {
            e.preventDefault();
            if (this != dragged) {
                let draggedpos = 0, droppedpos = 0;
                for(let it = 0; it < items.length; it++){
                    if (dragged == items[it]) draggedpos = it;
                    if (this == items[it]) droppedpos = it;
                }
                if (draggedpos < droppedpos) this.parentNode.insertBefore(dragged, this.nextSibling);
                else this.parentNode.insertBefore(dragged, this);
            }
            dragged = null;
        });
    }
    for (let i of items)addListener(i);
    $ff443a58ea3178ba$var$observeDOM(target, function(m) {
        if (m[0].target.children.length > currentLength) {
            for (let i of m[0].addedNodes)addListener(i);
            currentLength = m[0].target.children.length;
        } else if (m[0].target.children.length < currentLength) currentLength--;
    });
}
function $ff443a58ea3178ba$export$a11733f716447e79(targetEl) {
    const target = targetEl || document;
    target.querySelectorAll('[data-sortable]').forEach((elm)=>{
        $ff443a58ea3178ba$var$slist(elm);
    });
}


function $1510fe988b004a9a$export$eb5ff443d10caf06(config = {}, target = null) {
    const { flatpickr: flatpickr, formSubmitInterfere: formSubmitInterfere, sidebar: sidebar } = config;
    (0, $f8b375dfe567b691$export$34107ba18b519094)(target);
    (0, $f0e8230e30da36c4$export$7d03d001ca71c65f)(target);
    (0, $562ab1c19ca475c0$export$70070ff97f1a4ca0)(target);
    (0, $cc6bb940a375faba$export$ed8a68ffbc322e67)(flatpickr, target);
    (0, $c3a7231574a3ce7f$export$a4d38683f8b8b9ce)(target);
    (0, $304388bf04a27446$export$823a7882fb5f7a04)(formSubmitInterfere, target);
    (0, $35575bba3d0279d6$export$aa70e201a98a0ce4)(target);
    (0, $360e565dd160cbbd$export$60523367a7e10402)(target);
    (0, $713101f52d4e2e3f$export$e30e8b9f67d70081)(target);
    (0, $415c60d76e295d48$export$4b39ebe2dc5b79d6)(sidebar);
    (0, $ff443a58ea3178ba$export$a11733f716447e79)(target);
    (0, $c5c12cc6dc5fd685$export$a4db3bf4a43c81e3)(target);
}


export {$1510fe988b004a9a$export$eb5ff443d10caf06 as initAll, $f8b375dfe567b691$export$34107ba18b519094 as initCollapsible, $f0e8230e30da36c4$export$7d03d001ca71c65f as initConfirmable, $cc6bb940a375faba$export$ed8a68ffbc322e67 as initDatepicker, $c5c12cc6dc5fd685$export$a4db3bf4a43c81e3 as initDetectDropdownPositions, $562ab1c19ca475c0$export$70070ff97f1a4ca0 as initDetectFormChanges, $c3a7231574a3ce7f$export$a4d38683f8b8b9ce as initFileInput, $304388bf04a27446$export$823a7882fb5f7a04 as initFormSubmitInterfere, $35575bba3d0279d6$export$aa70e201a98a0ce4 as initLiveSearch, $360e565dd160cbbd$export$60523367a7e10402 as initModal, $713101f52d4e2e3f$export$e30e8b9f67d70081 as initNotification, $415c60d76e295d48$export$4b39ebe2dc5b79d6 as initSidebar, $ff443a58ea3178ba$export$a11733f716447e79 as initSortable};
//# sourceMappingURL=main.js.map
